import masks from '../../../utils/masks.json';

const schema = {
    numeroDoContrato: {
        id: 'numeroContrato',
        label: 'Número do contrato',
        disabled: true,
        value: '...',
    },
    cnpj: {
        id: 'cnpj',
        label: 'CNPJ',
        disabled: true,
        value: '...',
        mask: masks.cnpj,
    },
    razaoSocial: {
        id: 'razaoSocial',
        label: 'Razão social',
        disabled: true,
        value: '...',
    },
    situacao: {
        id: 'situacao',
        label: 'Situação',
        disabled: true,
        value: '...',
    },
    diaVencimentoFatura: {
        id: 'diaVencimentoFatura',
        label: 'Dia de vencimento da fatura',
        disabled: true,
        value: '...',
    },
    dataLimiteEnvio: {
        id: 'dataLimiteEnvio',
        label: 'Data limite para movimentação',
        disabled: true,
        value: '...',
    },
};

export default schema;
